import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=15ac6332&scoped=true&"
import script from "./ReportTable.vue?vue&type=script&lang=js&"
export * from "./ReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=15ac6332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ac6332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VProgressLinear,VRow,VSimpleTable})
